import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardTypes } from '@src/suite/common/enums/clipboard-types';
import { ViewStateLayouts } from '@src/suite/common/enums/viewstate-layouts';
import { ViewStateTypes } from '@src/suite/common/enums/viewstate-types';
import { selectListIsLargeView } from '@src/suite/common/store/breakpoints/breakpoints.selectors';
import { CreateViewStateActions } from '@src/suite/common/store/createviewstate/createviewstate.actions';
import { selectCurrentLayoutValue, selectCurrentViewStateType } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { selectPlaybookListRecords } from '@src/suite/common/store/playbook/playbook.selector';

import { BaseSecondaryCtaComponent } from '../base-secondary-cta.component';

@Component({
    selector: 'st-playbook-secondary-cta',
    imports: [MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule, MatTooltipModule],
    templateUrl: './playbook-secondary-cta.component.html',
    styleUrl: './playbook-secondary-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-playbook-secondary-cta',
    },
})
export class PlaybookSecondaryCtaComponent extends BaseSecondaryCtaComponent {
    ViewStateLayouts = ViewStateLayouts;
    selectListRecords = this.store.selectSignal(selectPlaybookListRecords);
    selectViewStateType = this.store.selectSignal(selectCurrentViewStateType);
    selectViewStateLayout = this.store.selectSignal(selectCurrentLayoutValue);

    readonly viewStateLoaded = computed(() => {
        return !!this.viewState();
    });

    readonly shouldShowCustomFieldsOption = computed(() => {
        if (this.selectViewStateLayout() === ViewStateLayouts.CONDENSE || this.selectViewStateLayout() === ViewStateLayouts.CARD) {
            return this.store.selectSignal(selectListIsLargeView)();
        }
        return false;
    });

    readonly isSaveButtonDisabled = computed(() => {
        return !this.saveViewSettingsEnabled() && !this.saveAsViewSettingsEnabled();
    });

    public copyToClipboard() {
        if (this.viewState()?.PSTViewStateType === ViewStateTypes.TOPIC) {
            this.appService.clipboard.copy(this.selectListRecords(), ClipboardTypes.TopicView);
        } else if (this.viewState()?.PSTViewStateType === ViewStateTypes.ASSIGNMENT) {
            this.appService.clipboard.copy(this.selectListRecords(), ClipboardTypes.AssignmentView);
        } else if (this.viewState()?.PSTViewStateType === ViewStateTypes.SCRIPT) {
            this.appService.clipboard.copy(this.selectListRecords(), ClipboardTypes.StoryView);
        } else {
            this.appService.clipboard.copy(this.selectListRecords(), ClipboardTypes.SearchView);
        }
    }

    editView() {
        this.store.dispatch(CreateViewStateActions.createUpdateViewState({ edit: true, copy: false, vs: this.viewState(), localUpdate: true }));
    }
}
